{
  "LOGIN": {
    "TITLE": "Войти в Chatwoot",
    "EMAIL": {
      "LABEL": "Email",
      "PLACEHOLDER": "example{'@'}companyname.com",
      "ERROR": "Пожалуйста, введите действительный адрес электронной почты"
    },
    "PASSWORD": {
      "LABEL": "Пароль",
      "PLACEHOLDER": "Пароль"
    },
    "API": {
      "SUCCESS_MESSAGE": "Вход выполнен",
      "ERROR_MESSAGE": "Не удалось подключиться к Woot серверу. Пожалуйста, попробуйте еще раз.",
      "UNAUTH": "Неверное имя пользователя или пароль. Пожалуйста, попробуйте еще раз."
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Войти с помощью Google",
      "BUSINESS_ACCOUNTS_ONLY": "Пожалуйста, используйте адрес электронной почты вашей компании для входа",
      "NO_ACCOUNT_FOUND": "Мы не смогли найти учетную запись для вашего адреса электронной почты."
    },
    "FORGOT_PASSWORD": "Забыли пароль?",
    "CREATE_NEW_ACCOUNT": "Создать новый аккаунт",
    "SUBMIT": "Вход",
    "SAML": {
      "LABEL": "Войти через SSO",
      "TITLE": "Инициировать Единый вход (SSO)",
      "SUBTITLE": "Введите ваш рабочий email для доступа к вашей организации",
      "BACK_TO_LOGIN": "Войти с помощью пароля",
      "WORK_EMAIL": {
        "LABEL": "Рабочий email",
        "PLACEHOLDER": "Введите ваш рабочий email"
      },
      "SUBMIT": "Продолжить через SSO",
      "API": {
        "ERROR_MESSAGE": "Ошибка аутентификации SSO. Пожалуйста, проверьте ваши учетные данные и повторите попытку."
      }
    }
  }
}
